import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ranking-user" }
const _hoisted_2 = { class: "ranking-user-left" }
const _hoisted_3 = { class: "ranking-number" }
const _hoisted_4 = { class: "ranking-user-right" }
const _hoisted_5 = { class: "user-name" }
const _hoisted_6 = { class: "user-score" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "user-score-span" }, "score", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("p", _hoisted_3, _toDisplayString(_ctx.index + 4), 1),
      _createVNode("img", {
        class: "user-circle",
        src: _ctx.path
      }, null, 8, ["src"])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("p", _hoisted_5, _toDisplayString(_ctx.name), 1),
      _createVNode("p", _hoisted_6, [
        _createTextVNode(_toDisplayString(_ctx.score) + " ", 1),
        _hoisted_7
      ])
    ])
  ]))
}